import { useTranslation } from 'react-i18next';
import { useBackdropContext } from '../../../context/backdrop';
import { useGraphqlContext } from '../../../context/graphql';
import { toastError } from '../../../utils/toast';
import { useAuth } from '../../../hooks/auth/use-auth';

export const useSetProfileImage = () => {
  const { keycloak } = useAuth();
  const { t } = useTranslation('profile');
  const { t: tc } = useTranslation('common');
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { LAVVA_MANAGER } = useGraphqlContext();

  const setProfileImage = (file: File, onSuccess: () => void) => {
    turnOnBackdrop();
    const formData = new FormData();
    formData.append('file', file);
    fetch(`${LAVVA_MANAGER}Upload/Profile`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${keycloak.token}`,
      },
      body: formData,
    })
      .then((data) => {
        if (data.status === 200) onSuccess();
        else if (data.status === 400 || data.status === 404 || data.status === 500) {
          toastError({ content: tc('errors.somethingWentWrong') });
        } else if (data.status === 413) {
          toastError({ content: t('avatar.toastSizeError') });
        }
      })
      .catch(() => {
        toastError({ content: tc('errors.somethingWentWrong') });
      })
      .finally(() => {
        turnOffBackdrop();
      });
  };

  return {
    setProfileImage,
  };
};
